import { render, staticRenderFns } from "./FeatureTag.vue?vue&type=template&id=47898430&scoped=true&lang=pug&"
import script from "./FeatureTag.vue?vue&type=script&lang=js&"
export * from "./FeatureTag.vue?vue&type=script&lang=js&"
import style0 from "./FeatureTag.vue?vue&type=style&index=0&id=47898430&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47898430",
  null
  
)

export default component.exports